import React from 'react';
import Page from "../components/Page";
import SettingsNavbar from '../components/SettingsNavbar';
import { Outlet, useLocation, Navigate, Link } from 'react-router-dom';
import { useStoreSettings } from '../controllers/settings.controller';
import { getUserDetailsInLocalStorage } from '../helpers/UserDetails';
import { isSettingVisible, SETTINGS_CONFIG_MAP } from '../helpers/SettingsVisibility';
import { IconShieldLock, IconArrowLeft } from '@tabler/icons-react';

export default function SettingsPage() {
  const { pathname } = useLocation();
  const { data: storeSettings } = useStoreSettings();
  const user = getUserDetailsInLocalStorage() || {};

  const modulesStr = (storeSettings?.enabled_modules !== undefined && storeSettings?.enabled_modules !== null)
    ? storeSettings.enabled_modules
    : user.enabled_modules;

  // Find if current path corresponds to a controlled setting option
  let matchedSetting = SETTINGS_CONFIG_MAP.find(item => 
    item.exact ? item.path === pathname : pathname.startsWith(item.path)
  );

  // Determine if this setting is allowed
  const isAllowed = matchedSetting
    ? isSettingVisible(matchedSetting.settingKey, matchedSetting.parentModule, modulesStr)
    : true;

  // If user visits the root /dashboard/settings but store-details is disabled,
  // find the first available setting path and redirect smoothly
  if ((pathname === "/dashboard/settings" || pathname === "/dashboard/settings/") && !isAllowed) {
    const firstEnabled = SETTINGS_CONFIG_MAP.find(item => 
      item.path !== "/dashboard/settings" &&
      item.path !== "/dashboard/settings/details" &&
      item.path !== "/dashboard/settings/store-details" &&
      isSettingVisible(item.settingKey, item.parentModule, modulesStr)
    );
    if (firstEnabled) {
      return <Navigate to={firstEnabled.path} replace />;
    }
  }

  return (
    <Page className='flex h-[calc(92vh-20px)]'>
      <SettingsNavbar />
      <div className='flex-1 h-full overflow-y-auto'>
        {isAllowed ? (
          <Outlet />
        ) : (
          <div className="flex flex-col items-center justify-center h-full p-8 text-center">
            <div className="w-16 h-16 rounded-2xl bg-amber-500/10 border border-amber-500/20 flex items-center justify-center text-amber-500 mb-4 shadow-sm">
              <IconShieldLock size={36} stroke={1.75} />
            </div>
            <h3 className="text-xl font-bold text-gray-800 dark:text-gray-100 mb-2">
              Setting Option Disabled
            </h3>
            <p className="text-sm text-gray-500 dark:text-gray-400 max-w-md mb-6 leading-relaxed">
              Access to <strong>{matchedSetting?.title || "this setting option"}</strong> has been restricted for your hotel organization by the Super Administrator.
            </p>
            <div className="flex items-center gap-3">
              <Link
                to="/dashboard"
                className="btn btn-sm rounded-xl px-4 border border-gray-200 dark:border-zinc-700 bg-white dark:bg-zinc-800 hover:bg-gray-100 dark:hover:bg-zinc-700 text-gray-700 dark:text-gray-300 flex items-center gap-1.5 transition active:scale-95"
              >
                <IconArrowLeft size={16} />
                Return to Dashboard
              </Link>
            </div>
          </div>
        )}
      </div>
    </Page>
  );
}
